import { useMutation, useMutationState, useQueryClient } from "@tanstack/react-query";
import { generateCaseSummary } from "../api/caseSummary";

const SUMMARY_WRITE = ["case-summary"];

// The summary lives on the matter, so the matter query is what carries the
// new text back; the call stays pending until it has. Every matter query is
// invalidated, as DocWall does: the page may hold the matter under an eId
// that is not the one the server now answers with.
export function useGenerateCaseSummary() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: SUMMARY_WRITE,
    mutationFn: generateCaseSummary,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["matter"] }),
  });
}

// A write takes half a minute and outlives the page that started it: the
// cache, not the component, says whether this matter's latest write is still
// running or was refused.
export function useCaseSummaryWrite(caseId: string | undefined): {
  pending: boolean;
  error: string | null;
} {
  const states = useMutationState({
    filters: { mutationKey: SUMMARY_WRITE, predicate: (m) => m.state.variables === caseId },
    select: (m) => m.state,
  });
  const last = states[states.length - 1];
  return {
    pending: last?.status === "pending",
    error: last?.status === "error" ? (last.error?.message ?? null) : null,
  };
}
